import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { clearRetailSessionStorage } from "@/src_new/shared/lib/authSession";
import { App_Url_New } from "@/src_new/shared/common/static";
import { showToast } from "@/src_new/shared/lib/toast";
import { closeModal } from "@/src_new/shared/redux/reducers/uiSlice";
import { clearAllReduxData } from "@/src_new/shared/redux/store/store";

import { Button } from "./Button";

type CommonLogoutModalProps = {
  displayName?: string;
};

export default function CommonLogoutModal({ displayName = "" }: CommonLogoutModalProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleClose = () => {
    if (isLoggingOut) return;
    dispatch(closeModal());
  };

  const handleConfirmLogout = async () => {
    if (isLoggingOut) return;

    setIsLoggingOut(true);
    const normalizedDisplayName = displayName.trim();

    await clearAllReduxData();
    clearRetailSessionStorage();

    showToast(
      normalizedDisplayName
        ? `Goodbye, ${normalizedDisplayName}. You have been logged out successfully.`
        : "You have been logged out successfully.",
      "success"
    );

    navigate(App_Url_New.secured.frontlinks.login, { replace: true });
    setIsLoggingOut(false);
  };

  return (
    <div className="w-full space-y-5">
      <div className="space-y-2 py-3">
        <p className="text-md leading-6 text-theme-text">Are you sure you want to log out?</p>
      </div>

      <div className="flex justify-end gap-3">
        <Button
          type="button"
          variant="secondary"
          disabled={isLoggingOut}
          onClick={handleClose}
          className="min-h-auto rounded-lg px-4 py-2 text-sm"
        >
          No
        </Button>
        <Button
          type="button"
          disabled={isLoggingOut}
          onClick={handleConfirmLogout}
          className="min-h-auto rounded-lg !bg-theme-danger px-4 py-2 text-sm font-semibold text-theme-text-inverse disabled:opacity-60"
        >
          {isLoggingOut ? "Logging out..." : "Yes, logout"}
        </Button>
      </div>
    </div>
  );
}
